import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import QuickPanelToggler from "./QuickPanelToggle";

import "../../../app/components/DashStyle/topbar.scss"; // RHC-DASH-STYLE: Obviously this is garbage. ¯\_(ツ)_/¯

export default function Topbar({ isDashStyle = false }) {
  // RHC-DASH-STYLE-UPDATE: Add the props

  // const pathname = useLocation().pathname													// RHC-DASH-STYLE
  // (below) Get from redux. Random here to show different 								   RHC-DASH-STYLE
  //  styles for 0, 1,8 and 9+. max set to show 9+ more often.							   RHC-DASH-STYLE
  const noteCount = Math.floor(Math.random() * 15); // RHC-DASH-STYLE:

  const role = useSelector((state) => state.auth.roleDesc);
  const [show, setShow] = useState(false);
  // const ConditionalWrapper = ({ condition, wrapper, children }) => condition ? wrapper(children) : children;	// RHC-DASH-STYLE-UPDATE: Overkill but you may eventually have more than just the help item.

  return (
    <>
      <div className="kt-header__topbar" style={{ paddingTop: 20, cursor: "pointer" }}>
        <QuickPanelToggler noteCount={noteCount} />
      </div>
    </>
  );
}
